import axios from "axios";

import AuthService from '../Auth/AuthService';

export default class CrachaService extends AuthService {


  /* LISTAR TODOS */
  listar() {
    return axios({
      method: 'get',
      url: this.api_url + 'cracha',
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      },
    }).then(res => res.data);
  }
  /* CADASTRAR */
  criar(cracha) {
    return axios({
      method: 'post',
      url: this.api_url + 'cracha',
      withCredentials: true,
      data: cracha,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });
  }
  /* REMOVER */
  remover(id) {
    return axios({
      method: 'delete',
      url: this.api_url + 'cracha/' + id,
      withCredentials: true,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });

  }
  /* ATUALIZAR */
  atualizar(id, cracha) {
    return axios({
      method: 'put',
      url: this.api_url + 'cracha/' + id,
      withCredentials: true,
      data: cracha,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });
  }
  /* ATUALIZAR STATUS*/
  atualizarStatus(id, cracha) {
    return axios({
      method: 'put',
      url: this.api_url + 'cracha/ativo/' + id,
      withCredentials: true,
      data: cracha,
      headers: {
        'Authorization': 'Bearer ' + this.token(),
      }
    });
  }

}
